/* eslint-disable max-len */
import React, {useEffect, useState} from "react";
import "../../stylesheets/screen.css.scss";
import ParameterContainer from "../ParameterContainer/ParameterContainer";
import CodeContainer from "../CodeContainer/CodeContainer";
import dummydata from "../../Data/dummy.json";
import {convertJSONintoPreferredTryOutFormat} from "../../utils/tryOutUtils";
import {useMyContext} from "../../context/MyContext";
import { FaTimes } from "react-icons/fa";

function resolveRef(ref, json) {
  const path = ref.split("/").slice(1);
  return path.reduce((acc, key) => acc[key], json);
}

function TryOut() {
  const {setShowTryOut, method} = useMyContext();
  const {Headers} =
  convertJSONintoPreferredTryOutFormat(method);

  const requestBodyParams = method?.requestBody;
  const content = requestBodyParams?.content;
  const requestBody = content && Object.entries(content).map((item)=>{
    const {schema: {value}}= item[1];
    return value;
  });
  const resolvedSchema=requestBody&&requestBody[0];


  const contentTypeHeader = Headers.find((header) => header?.name?.toLowerCase() === "content-type");



  const transformSchema = (schema) => {
    if (!schema || !schema.properties) {
      return {};
    }

    const transformProperty = (property) => {
      const {type, properties, items} = property;

      if (type === "object") {
        if (properties) {
          return transformProperties(properties);
        } else {
          const nextObj = Object.values(property);
          const nextProperties = nextObj[0]["properties"] || nextObj[1]["properties"];
          return nextProperties ? transformProperties(nextProperties) : {};
        }
      } else if (type === "array" && items) {
        if (items.type && items.type !== "object") {
          return [transformProperty(items)];
        } else if (items["properties"]) {
          return [transformProperty(items)];
        } else {
          const nextObj = Object.values(items);
          return [transformProperties(nextObj[0]["properties"] || nextObj[1]["properties"])];
        }
      } else {
        return type || "string";
      }
    };


    const transformProperties = (properties) => {
      const transformedProperties = {};

      for (const [key, value] of Object.entries(properties)) {
        if (value.type) {
          transformedProperties[key] = transformProperty(value);
        } else {
          const nextObj = Object.values(value);

          if (nextObj[0]["items"]) {
            transformedProperties[key] = transformProperty(nextObj[0]["items"]);
          } else if (nextObj[0]["properties"]) {
            transformedProperties[key] = transformProperties(nextObj[0]["properties"]);
          } else {
            transformedProperties[key] = transformProperty(value);
          }
        }
      }

      return transformedProperties;
    };


    return transformProperties(schema.properties);
  };
  const transformedUser = transformSchema(resolvedSchema);


  const initialInputValues = {
    Accept: "application/json",
    Body: !(contentTypeHeader&&contentTypeHeader.value==="multipart/form-data")?JSON.stringify(transformedUser, null, "  "):null,
  };

  // If "Content-Type" header is present, add it to the initialInputValues state
  if (contentTypeHeader) {
    initialInputValues["Content-type"] = contentTypeHeader.value;
  }

  const authorizationHeader = Headers.find((header) => header.name.toLowerCase() === "authorization");
  if (authorizationHeader) {
    initialInputValues["Authorization"] = "Bearer";
  }

  const [inputValues, setInputValues] = useState(initialInputValues);


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.classList.contains("tryOut-btn")&&!event.target.classList.contains("tryout-modal") && !event.target.closest(".tryout-modal")) {
        // If the click is outside the modal, close it
        setShowTryOut(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [setShowTryOut]);

  const handleInputChange = (name, value) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return (
    <div id ="myModal"className=" modal tryout show">
      <div className="modal-content tryout-modal">
        <div className="tryout-container" id="tryout">
          <div className="tryout-content">
            <div className="tryout-header-container">
              <div className="tryout-title">
                <div className="heading">Try this method</div>
                <div className="close-icon"><FaTimes onClick={()=>setShowTryOut(false)} /></div>
              </div>
              <div className="tryout-controls">
              </div>
            </div>
            <div className="tryout-body-container" id="tryout-body-container">
              <ParameterContainer inputValues={inputValues} onInputChange={handleInputChange} method={method} />
              <CodeContainer inputValues={inputValues} method={method} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default TryOut;
